module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-Dundee-b3809ba5882850110e1c2bf5e80416e3.svg";